// UserContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';
import jwtAxios from '@projectK/services/auth/JWT';
import PropsTypes from 'prop-types';
import { useAuthUser } from '@projectK/hooks/AuthHooks';
import {
  isStudent,
  isParent,
  isActualAdmin,
  isActualSuperAdmin,
  isActualCoach,
  isAdmin,
  isSuperAdmin,
  isCoach,
} from '@projectK/context/RolesProvider';
import { useAddonsSettings } from '@projectK/context/CheckAdddons';
import { paymentRecovery } from '@projectK/constants/AppEnums';

// Create a Context
const GeneralContext = createContext();

// Create a Provider component
export const CheckMissedPaymentContextProvider = ({ children }) => {
  const [checkMissedPayment, setCheckMissedPayment] = useState(false); //NOSONAR
  const [checkGracePeriodPayment, setCheckGracePeriodPayment] = useState([]); //NOSONAR
  const [isLoading, setIsLoading] = useState(true);
  const { CheckAdddonsSettings, loading } = useAddonsSettings();
  const hasPaymentRecoveryAddon =
    CheckAdddonsSettings?.includes(paymentRecovery); // Check if payment recovery addon exists

  const { user } = useAuthUser();
  const isActualMainUser =
    isActualSuperAdmin(user) ||
    isActualAdmin(user) ||
    isActualCoach(user) ||
    isAdmin(user) ||
    isSuperAdmin(user) ||
    isCoach(user);
  const fetchcompanyData = async () => {
    setCheckGracePeriodPayment([]);
    try {
      const isStudentOrParent =
        !isActualMainUser && (isParent(user) || isStudent(user));
      if (!!isStudentOrParent && hasPaymentRecoveryAddon) {
        const response = await jwtAxios.get(
          `/payments-recovery-settings/restrict-user`,
          {
            params: {
              filters: {
                user_id: user?.id,
              },
            },
          },
        );
        const { data } = response;
        setCheckMissedPayment(data?.list?.length > 0)
      }
      if((isParent(user) || isStudent(user)) && hasPaymentRecoveryAddon){
        const responseGracePeriod = await jwtAxios.get(
          `/payments-recovery-settings/graceperiod/user`,
          {
            params: {
              filters: {
                user_id: user?.id,
              },
            },
          },
        );
        const { data:grace } = responseGracePeriod;
        setIsLoading(false);
        setCheckGracePeriodPayment(grace?.list);
      }
    } catch (error) {
      console.error('Error fetching appearance settings:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchcompanyData();
  }, [user?.id, loading]);

  return (
    <GeneralContext.Provider
      value={{//NOSONAR
        checkMissedPayment,
        checkGracePeriodPayment,
        isLoading,
      }}
    >
      {children}
    </GeneralContext.Provider>
  );
};
CheckMissedPaymentContextProvider.propTypes = {
  children: PropsTypes.any,
};

// Create a custom hook to use the context
export const useMissedPaymentSettings = () => useContext(GeneralContext);
